import { passwordStrength } from '../utils/passwordStrength';

const TONE = {
  empty:  { color: 'var(--muted)',   bar: 'var(--card-soft)' },
  weak:   { color: 'var(--danger)',  bar: 'var(--danger)' },
  medium: { color: 'var(--warning)', bar: 'var(--warning)' },
  strong: { color: 'var(--success)', bar: 'var(--success)' }
};

export default function PasswordStrengthMeter({ password = '', confirmPassword }) {
  const result = passwordStrength(password);
  const tone = TONE[result.key];
  const showMatch = typeof confirmPassword === 'string' && confirmPassword.length > 0;
  const matches = showMatch && password === confirmPassword;

  return (
    <div className="stack-sm" style={{ gap: 6 }}>
      <div style={{ height: 4, borderRadius: 2, background: 'var(--card-soft)', overflow: 'hidden' }}>
        <div style={{
          width: `${Math.round(result.ratio * 100)}%`,
          height: '100%',
          background: tone.bar,
          transition: 'width .2s ease, background .2s ease'
        }} />
      </div>
      <div className="row" style={{ justifyContent: 'space-between', fontSize: 11, fontWeight: 800 }}>
        <span style={{ color: tone.color }}>{result.label}</span>
        {showMatch ? (
          <span style={{ color: matches ? 'var(--success)' : 'var(--danger)' }}>
            {matches ? '✓ Passwords match' : 'Passwords do not match'}
          </span>
        ) : null}
      </div>
      <ul style={{ listStyle: 'none', padding: 0, margin: '4px 0 0', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 4 }}>
        {result.requirements.map((req) => (
          <li key={req.key} style={{ fontSize: 11, color: req.met ? 'var(--success)' : 'var(--muted)' }}>
            {req.met ? '✓' : '○'} {req.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
